import { OutboundLink } from 'gatsby-plugin-google-gtag';
import React from 'react';
import { ExternalLink } from 'react-feather';
import { CryptoUtils } from 'utils/cryptoUtils';
import { StorageUtils } from 'utils/storageUtils';
import Tooltip from './Tooltip/Tooltip';
import { ChainUtils } from 'utils/chainUtils';
import { useAccount } from 'wagmi';
import useSelectedChain from 'hooks/useSelectedChain';

export const Transactions: React.FC = () => {
  const [storedTxs, setStoredTxs] = React.useState<StorageUtils.StoredTx[]>([]);
  const { chainId } = useSelectedChain();
  const { address, isConnected } = useAccount();

  const queryStoredTxs = () => {
    if (address && chainId) {
      StorageUtils.getAccountTxs(address, chainId)
        .then((result) => {
          setStoredTxs(result);
        })
        .catch((e) => {
          console.warn(e);
        });
    }
  };

  React.useEffect(() => {
    const subscription = StorageUtils.txSubject$.subscribe(() => {
      queryStoredTxs();
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [StorageUtils.txSubject$, isConnected, chainId]);

  // Whenever accountAddress or chainId change re-query
  React.useEffect(() => {
    if (isConnected) {
      queryStoredTxs();
    }
  }, [isConnected]);

  const clearTransaction = (tx: StorageUtils.StoredTx) => {
    if (address && chainId) {
      void StorageUtils.removeTx({
        ...tx,
        accountAddress: address,
        chainId: chainId,
      });
      console.debug('Successfully cleared tx', tx);
    }
  };

  if (!storedTxs || storedTxs?.length === 0) {
    return <div>Pending Transactions will appear here...</div>;
  }

  return (
    <div className="flex flex-col">
      {isConnected && chainId
        ? storedTxs.map((tx) => (
            <div
              className="flex flex-row items-center justify-between"
              key={tx.hash}
            >
              <div>{tx.labels?.executing ?? 'Transaction'}</div>
              <OutboundLink
                className="wallet-etherscan-color"
                target="_blank"
                href={
                  CryptoUtils.getScannerInfo(chainId, tx.hash, 'transaction')
                    ?.link
                }
              >
                <div className="inline-flex items-center">
                  <span>{ChainUtils.ellipseAddress(tx.hash, 4)}</span>
                  <ExternalLink width={16} height={16} className="ml-5" />
                </div>
              </OutboundLink>
              <Tooltip
                message="Clear transaction from local cache"
                position="left"
                bubbleSize={{ width: '200px' }}
              >
                <img
                  onClick={() => clearTransaction(tx)}
                  className="icon-close cursor-pointer"
                  alt="Clear transaction from local cache"
                />
              </Tooltip>
            </div>
          ))
        : null}
    </div>
  );
};
